import * as React from "react";
import { Stack, Box, Typography, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function InnerPage(props) {
  const theme = useTheme();
  
  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.background.default,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        // width: "100%",

        // marginTop: "15px",
        marginTop: 5,
        marginLeft: 0,
        // marginLeft: "180px",
        marginLeft: {
          lg: "240px",
          sm: 0,
        },
      }}
    >
      {/* <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 800,
          color: "white",
          marginTop: "20px",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        {props.title}
      </Typography> */}
      <Box
        sx={{
          marginTop: "0",
          backgroundColor: theme.palette.background.default,
          borderTopRightRadius: "20px",
          borderTopLeftRadius: "20px",
          minHeight: "100vh",
          width: "100%",
          overflow: "auto",
        }}
      >
        {props.children}
      </Box>
    </Stack>
  );
}
